import ActionTypeItem from "../ActionTypeItem";

export default class CargaDeItemsBuscados extends ActionTypeItem {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = false;
        nuevoEstado.data = this.payload;
        return nuevoEstado;
    }
}
